import { DataServer } from "../../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface RackingTypesState {
  RackingTypes: {
    load: boolean;
    data: [];
  };
}

export const RackingTypesSlice = createSlice({
  name: "RackingTypes",
  initialState: {
    RackingTypes: {
      load: false,
      data: [],
    },
  } as RackingTypesState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchRackingTypes.pending, (state: RackingTypesState) => {
        state.RackingTypes.load = true;
      })
      .addCase(fetchRackingTypes.fulfilled, (state: RackingTypesState, action: any) => {
        state.RackingTypes.data = action.payload;
        state.RackingTypes.load = false;
      })
      .addCase(fetchRackingTypes.rejected, (state: RackingTypesState) => {
        state.RackingTypes.load = false;
      });
  },
});

export default RackingTypesSlice.reducer;

export const fetchRackingTypes = createAsyncThunk(
  "RackingType/fetchRackingTypes",
  async (param:  any, thunkAPI) => {
    try {
      const { data } = await DataServer.post("api/getAllRackingTypes");
      return data.data;
    } catch (error) {
    }
  }
);